import React, { useState } from "react";
// import ButtonPrimary from "components/Button/ButtonPrimary";
import Input from "components/Input/Input";
import Label from "components/Label/Label";
import SocialsList from "components/SocialsList/SocialsList";
// import Textarea from "components/Textarea/Textarea";
import Heading2 from "components/Heading/Heading2";
import Layout from "../layout";
import cogoToast from "cogo-toast"
import { BACKEND_URL } from "constants"
import HeaderFilter from "components/Sections/HeaderFilter"

const info = [
  {
    title: "Adres",
    desc: "Portal Respublica ul. Podolska 22 48-303 Nysa",
  },
  {
    title: "E-mail",
    desc: "kontakt@respublica.com.pl",
  },
  {
    title: "Numer telefonu",
    desc: "+48 666 895 859",
  },
];

const PageNewsletter = () => {
  const [name,setName] = useState("")
  // const [message, setMessage] = useState("")
  const [email,setEmail] = useState("")
  const [accepted, setAccepted] = useState(false);


  const changeData = (e) => {
  if(e.target.name === "name"){
      setName(e.target.value)
  }
  else{
      setEmail(e.target.value)
  }
}
const sendMail = async (event) => {
  event.preventDefault(); // Zatrzymuje domyślne działanie formularza

  if (name === "" || email === "") {
    cogoToast.error("Proszę uzupełnić wszystkie pola formularza");
    return;
  }
  
  if (!accepted) {
    cogoToast.error("Proszę wyrazić zgodę na przetwarzanie danych osobowych.");
    return;
  }

  const payload = {
    name,
    email
  };

  try {
    const response = await fetch(`${BACKEND_URL}/sendMessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.statusCode === 200) {
      alert("Wiadomość została pomyślnie wysłana!");
      setName("");
      setEmail("");
      setAccepted(false);
    } else {
      alert("Wystąpił błąd przy wysyłaniu wiadomości.");
    }
  } catch (error) {
    console.error("Błąd:", error);
    alert("Wystąpił nieoczekiwany błąd.");
  }
};

  return (
    <div>
    <HeaderFilter heading="Newsletter"/>
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-28 ">
        <Heading2>Zapisz sie do Newslettera</Heading2>
        <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
        Napisz do nas, a my skontaktujemy się z Tobą.
        </span>
      </header>

      <div className="grid gap-8 lg:grid-cols-2">
        <div className="max-w-sm space-y-6">
          {info.map((item, index) => (
            <div key={index}>
              <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                {item.title}
              </h3>
              <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                {item.desc}
              </span>
            </div>
          ))}
          <div>
            <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
              Media społecznościowe
            </h3>
            <SocialsList className="mt-2" />
          </div>
        </div>
        <div className="border border-neutral-100 dark:border-neutral-700 lg:hidden"></div>
        <div>
        <form onSubmit={sendMail} className="grid grid-cols-1 gap-6">
  <label className="block">
    <Label htmlFor="name">Imię i nazwisko</Label>
    <Input
      id="name"
      name="name"
      value={name}
      onChange={changeData}
      type="text"
      className="mt-1"
      required
    />
  </label>

  <label className="block">
    <Label htmlFor="email">Adres e-mail</Label>
    <Input
      id="email"
      name="email"
      value={email}
      onChange={changeData}
      type="email"
      className="mt-1"
      required
    />
  </label>

  {/* <label className="block">
    <Label htmlFor="message">Wiadomość</Label>
    <Textarea
      id="message"
      name="message"
      value={message}
      onChange={changeData}
      className="mt-1"
      rows={6}
      required
    />
  </label> */}

  <div className="flex gap-2 items-baseline">
  <input
  type="checkbox"
  id="privacy"
  name="privacy"
  checked={accepted}
  onChange={() => setAccepted(!accepted)}
/>
    <label style={{fontSize:"12px", textAlign:"justify"}} htmlFor="privacy" className="text-sm">
    Wyrażam zgodę na przetwarzanie moich danych osobowych przez WORLD DEVELOPMENTS Sp. z o.o w celu przesyłania mi newslettera, zawierającego informacje handlowe i marketingowe, zgodnie z polityką prywatności. Zgoda jest dobrowolna i mogę ją w każdej chwili wycofać.
      {/* <a
        href="polityka-prywatnosci.html"
        className="underline text-blue-600 hover:text-blue-800"
      >
        polityką prywatności
      </a>. */}
    </label>
  </div>

  <button style={{backgroundColor:"#ac7c08"}}
    type="submit"
    className="bg-blue-600 text-white px-4 py-2 rounded hover"
  >
    Zapisz się
  </button>
</form>
        </div>
      </div>
    </Layout>
    </div>
  );
};

export default PageNewsletter;
